<template>
    <div>
        
    </div>
</template>
<script>
export default {
    props:{
        id:String
    },
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        
    },
}
</script>